"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _resources = _interopRequireDefault(require("../resources"));

var _appLanguages = require("../appLanguages");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var ResourceService =
/*#__PURE__*/
function () {
  function ResourceService() {
    _classCallCheck(this, ResourceService);
  }

  _createClass(ResourceService, null, [{
    key: "connect",
    value: function connect(store) {
      store.subscribe(function () {
        ResourceService.currentLanguage = store.getState().language;
      });
    }
  }, {
    key: "get",
    value: function get(path) {
      var dictAndLang = path.split('.');
      return _resources.default[dictAndLang[0]][ResourceService.currentLanguage.toLowerCase()][dictAndLang[1]];
    }
  }]);

  return ResourceService;
}();

ResourceService.currentLanguage = _appLanguages.appDefaultLanguage; // initialState.language;

var _default = ResourceService;
exports.default = _default;